var map = {
	"./icon-star-yellow.svg": 926,
	"./icon-star.svg": 927,
	"./q1.svg": 928,
	"./q2.svg": 929,
	"./q3.svg": 930,
	"./q4.svg": 931,
	"./q5.svg": 932
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 925;